import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { deleteCommission } from 'bundles/apex/deals/show/store/deal/actions';
import { internalBrokerLabel, isBrokerGrossHidden } from 'bundles/apex/deals/helpers/commissions';

import Card from 'bundles/apex/card';
import { Button } from 'components/ui/button';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';

import Broker from 'bundles/apex/deals/show/brokers/broker';
import Modal from './modal';
import UserIcon from 'components/user_icon';
import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function InternalBrokers({ deal, forUser, restrictBrokerGrossVisibilityToSelf, transactionSideOptions }) {
  const commissions = deal.commissions.filter(commission => !commission.outside);
  const [showModal, setShowModal] = useState(false);

  const closeModal = () => {
    setShowModal(false);
  };

  const controls = (
    <Button icon={faCirclePlus} label="Add broker" size="sm" variant="ghost" onClick={() => setShowModal(true)} />
  );

  let children;
  if (commissions.length == 0) {
    children = (
      <Empty className="bg-white">
        <Empty.Media>
          <FontAwesomeIcon icon={faUser} />
        </Empty.Media>
        <Empty.Title>No internal brokers have been added.</Empty.Title>
      </Empty>
    );
  } else {


    children = commissions.map((commission, i) => {
      const disableCommisionView = isBrokerGrossHidden(commission, forUser, restrictBrokerGrossVisibilityToSelf);
      const brokerLabel = internalBrokerLabel(i, commission.transactionSide, transactionSideOptions);

      return (
        <Broker
          commission={commission}
          deletable={commissions.length > 1}
          disableCommisionView={disableCommisionView}
          icon={<UserIcon size="xl" user={deal.brokers.find(broker => broker.id === commission.broker.id)} />}
          index={i}
          key={i}
        >
          <div>
            <div className="text-muted fs-small">
              {brokerLabel}
            </div>

            {commission.broker.name}
          </div>
        </Broker>
      );
    });
  }

  return <React.Fragment>
    <Card
      controls={controls}
      label="Internal Brokers"
      verticalBody
    >
      {children}
    </Card>

    <Modal
      forDeal
      show={showModal}
      onHide={closeModal}
    />
  </React.Fragment>;
}

InternalBrokers.propTypes = {
  deal: PropTypes.shape({
    brokers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
    })).isRequired,
    commissions: PropTypes.arrayOf(PropTypes.shape({
      broker: PropTypes.shape({
        id: PropTypes.number.isRequired,
      }),
      outside: PropTypes.bool,
    })).isRequired,
  }).isRequired,
  deleteCommission: PropTypes.func,
  forUser: PropTypes.shape({
    apexAdmin: PropTypes.bool,
    id: PropTypes.number.isRequired,
  }).isRequired,
  restrictBrokerGrossVisibilityToSelf: PropTypes.bool,
  transactionSideOptions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
};

const mapStateToProps = state => ({
  deal: state.deal,
  forUser: state.forUser,
  restrictBrokerGrossVisibilityToSelf: state.features.restrictBrokerGrossVisibilityToSelf,
  transactionSideOptions: state.options.transactionSide,
});

const mapDispatchToProps = {
  deleteCommission
};

export default connect(mapStateToProps, mapDispatchToProps)(InternalBrokers);
